
export const alerttypeData = [{ name: "Alerte personnalisée", id: 0 },
{ name: "Alerte prédéfinie", id: 1 }]

export const alerttypeDataNoPersonalized = [{ name: "Alerte prédéfinie", id: 1 }]

export const criticityData = [{ name: "Information", id: 0 },
{ name: "Avertissement", id: 1 },
{ name: "Important", id: 2 },
{ name: "Critique", id: 3 }]

export const granularityData = [{ name: "Horaire", id: "1h" },
{ name: "Journalière", id: "1d" },
{ name: "Mensuelle", id: "1M" },
{ name: "Annuelle", id: "1y" }]

export const dataTypeData = [
    { name: "Données calculées (indicateurs)", id: "indic" },
    { name: "Types de donnée", id: "def" },
    { name: "Points de donnée", id: "point" }]

export const numbercomparatorData = [{
    name: "number_equals",
    value: "="
}, {
    name: "number_greaterequals",
    value: ">="
}, {
    name: "number_lowerequals",
    value: "<="
}, {
    name: "number_greater",
    value: ">"
}, {
    name: "number_lower",
    value: "<"
}, {
    name: "number_different",
    value: "!="
}]

export const alertpredifinedrulesData = [
    { name: "Electricité - Absence de relève", id: 0, granularity: "1M", description: "Permet de vérifier si il y a eu une absence de relève sur les trois derniers mois sur les compteurs", category: "Facturation" },
    { name: "Electricité - Continuité d'index", id: 1, granularity: "1M", description: "L'index de début de facturation ne correspond pas à l'index de fin précédant", category: "Facturation" },
    { name: "Electricité - Facturation hors contrat", id: 2, granularity: "1M", description: "Une facture a été émise sur un PDL dont le contrat est fini", category: "Facturation" },
    { name: "Electricité - Coût contractuel du kWh", id: 3, granularity: "1M", description: "Le coût du kWh n'est pas cohérent avec le contrat", category: "Facturation" },
    { name: "Electricité - Dépassement facturé", id: 5, granularity: "1M", description: "Un dépassement de puissance a été facturé", category: "Facturation" },
    { name: "Gaz - Absence de relève", id: 10, granularity: "1M", description: "Permet de vérifier si il y a eu une absence de relève sur les trois derniers mois sur les compteurs", category: "Facturation" },
    { name: "Gaz - Continuité d'index", id: 11, granularity: "1M", description: "L'index de début de facturation ne correspond pas à l'index de fin précédant", category: "Facturation" },
    { name: "Gaz - Facturation hors contrat", id: 12, granularity: "1M", description: "Une facture a été émise sur un PDL dont le contrat est fini", category: "Facturation" },
    { name: "Gaz - Coût contractuel du kWh", id: 13, granularity: "1M", description: "Le coût du kWh n'est pas cohérent avec le contrat", category: "Facturation" },
]

export const getObjectFromId = (id, list) => {
    let newList = list.filter((listObject) =>
        listObject.id === id
    );
    if (newList.length > 0)
        return newList[0];
}

export const adanceddeffromdaydata = [
    { name: "Tous les jours", id: "all" },
    { name: "Tous les jours de la semaine", id: "weekdays" },
    { name: "Le samedi et dimanche", id: "weekenddays" },
    { name: "Du lundi", id: "2" },
    { name: "Du mardi", id: "3" },
    { name: "Du mercredi", id: "4" },
    { name: "Du jeudi", id: "5" },
    { name: "Du vendredi", id: "6" },
    { name: "Du samedi", id: "7" },
    { name: "Du dimanche", id: "1" },
];

export const adanceddeftodaydata = [
    { name: "Le samedi et dimanche", id: "weekenddays" },
    { name: "Au lundi", id: "2" },
    { name: "Au mardi", id: "3" },
    { name: "Au mercredi", id: "4" },
    { name: "Au jeudi", id: "5" },
    { name: "Au vendredi", id: "6" },
    { name: "Au samedi", id: "7" },
    { name: "Au dimanche", id: "1" },
];

export const adanceddefhourdata = [
    { name: "0h", id: "0" },
    { name: "1h", id: "1" },
    { name: "2h", id: "2" },
    { name: "3h", id: "3" },
    { name: "4h", id: "4" },
    { name: "5h", id: "5" },
    { name: "6h", id: "6" },
    { name: "7h", id: "7" },
    { name: "8h", id: "8" },
    { name: "9h", id: "9" },
    { name: "10h", id: "10" },
    { name: "11h", id: "11" },
    { name: "12h", id: "12" },
    { name: "13h", id: "13" },
    { name: "14h", id: "14" },
    { name: "15h", id: "15" },
    { name: "16h", id: "16" },
    { name: "17h", id: "17" },
    { name: "18h", id: "18" },
    { name: "19h", id: "19" },
    { name: "20h", id: "20" },
    { name: "21h", id: "21" },
    { name: "22h", id: "22" },
    { name: "23h", id: "23" },
];